import { CplaceSingleLocalizedTextControlChange, CplaceSingleLocalizedTextControlParameters } from '../../api/model/models';
import { ControlChangeHandler } from '../../controls';
import { mockControlIdentity, mockControlStateSharedData } from './controls.shared';

export const mockCplaceSingleLocalizedTextControlParams: CplaceSingleLocalizedTextControlParameters = {
  componentName: 'CplaceSingleLocalizedTextControlComponent',
  value: {
    supportedLocalizations: [
      { languageId: 'de', value: 'Textseite' },
      { languageId: 'en', value: 'Text Page' },
    ],
    unsupportedLocalizations: [],
  },
  isTextArea: false,
};

export const mockCplaceSingleLocalizedTextControlControlState = {
  ...mockControlStateSharedData,
  identity: mockControlIdentity,
  controlParameters: mockCplaceSingleLocalizedTextControlParams,
};

export const mockCplaceSingleLocalizedTextControlChangeHandler: ControlChangeHandler<
  CplaceSingleLocalizedTextControlChange,
  CplaceSingleLocalizedTextControlParameters
> = (controlParameters: CplaceSingleLocalizedTextControlParameters, controlChange: CplaceSingleLocalizedTextControlChange) => {
  return {
    ...controlParameters,
    value: controlChange.value,
  };
};
